export default {"src":"/_next/static/media/support-benefits.3c218274.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};